import { multiStyleConfig } from "@chakra-ui/theme-tools";
var alert = multiStyleConfig({
  parts: {
    container: "the alert container",
    title: "the alert title",
    icon: "the alert icon"
  },
  baseStyle: {
    container: {
      px: 4,
      py: 3,
      borderRadius: "md"
    },
    title: {
      fontWeight: "bold",
      lineHeight: "normal"
    },
    icon: {
      mr: 3,
      w: 5,
      h: 5
    }
  },
  variants: {
    subtle: function subtle(props) {
      var c = props.colorScheme;
      return {
        container: {
          bg: getBg(props),
          color: c + ".400"
        },
        icon: {
          color: c + ".300"
        }
      };
    }
  },
  defaultProps: {
    variant: "subtle"
  }
});

function getBg(props) {
  var c = props.colorScheme;
  return c + ".100";
}

export default alert;